import './MatchNote.scss';

import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';

import itsMacth from '../../../assets/images/MatchGame/itsMatch.png';
import keepPlaying from '../../../assets/images/MatchGame/keepPlaying.svg';
import sendMessage from '../../../assets/images/MatchGame/sendMessage.svg';
import MaleAvatar from '../../../assets/images/MembersAreaNavbar/ProfileAvatar.svg';
import {
  myProfile,
  showMemberProfilePage,
  showMessagesPage
} from '../../../pages/MainView/components/MembersAreaMain/navigation.service';
import { userData as userRecoil } from '../../../recoil/atoms/userDataAtom';
import ButtonWithIcon from '../../ButtonWithIcon/ButtonWithIcon';
import ImageN from '../../ImageN/ImageN';

const MatchNote = (props) => {
  const { matchProfile, closeModal, modalRef, matchName } = props;
  const [userData] = useRecoilState(userRecoil);
  const setAvatarPicture = () => {
    if (userData.data.profile.profile_image) {
      return (
        <ImageN
          name={userData?.data?.profile.profile_image}
          className="ProfilePhoto"
          classNameImg="ProfilePhoto"
        />
      );
    }
    return <img className="ProfilePhoto" src={MaleAvatar} alt="Profile-Avatar" />;
  };
  const setUserPicture = useCallback(() => {
    return matchProfile.avatar_image ? (
      matchProfile.avatar_image.thumbnail_url ? (
        <ImageN
          name={matchProfile.avatar_image.thumbnail_url}
          className="ProfilePhoto"
          classNameImg="ProfilePhoto"
        />
      ) : matchProfile.avatar_image ? (
        <ImageN
          name={matchProfile.avatar_image.url}
          className="ProfilePhoto"
          classNameImg="ProfilePhoto"
        />
      ) : (
        <img className="ProfilePhoto" src={matchProfile.profile_image} alt="Profile-Avatar" />
      )
    ) : (
      <img className="ProfilePhoto" src={matchProfile.profile_image} alt="Profile-Avatar" />
    );
  }, [matchProfile.profile_image, matchProfile.avatar_image]);
  const sendMessageToMacth = () => {
    showMessagesPage(matchProfile?.id);
  };
  const keepPlayingGame = () => {
    closeModal(modalRef);
  };
  return (
    <div className="MatchNote">
      <img src={itsMacth} className="itsMatch" alt={'match'} />
      <p className="Subtitle">You and {matchName} liked each other!</p>
      <div className="ProfileWrapper">
        <div className="matchImageWrapper" onClick={() => myProfile()}>
          {setAvatarPicture()}
        </div>
        <div className="matchImageWrapper" onClick={() => showMemberProfilePage(matchProfile?.id)}>
          {setUserPicture()}
        </div>
      </div>
      <ButtonWithIcon
        className="MatchButton"
        text={'send message'}
        iconSrc={sendMessage}
        onClick={sendMessageToMacth}
      />
      <ButtonWithIcon
        className="MatchButton1"
        text={'keep playing'}
        iconSrc={keepPlaying}
        onClick={keepPlayingGame}
      />
    </div>
  );
};
export default MatchNote;
